import React, { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { auth } from '../../firebase'
import { useRole } from '../../lib/roles'
import { hasPersonalTimesheet, hasWorkspaceAccess } from '../../lib/portalAccess.mjs'
import { clearOperatorSession } from '../../lib/OperatorContext'
import FeatureRequestButton from '../../components/FeatureRequestButton'

// Personal attendance uses the signed-in employee's account, slide and photo. The existing
// portal's shared workstation lock stays scoped to its operational workspace.
export default function TimesheetLayout() {
  const { role, attendanceEmployee } = useRole()
  const personalTimesheet = hasPersonalTimesheet(role, attendanceEmployee)
  const [user, setUser] = useState(auth.currentUser)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => onAuthStateChanged(auth, setUser), [])
  const leave = async () => {
    setBusy(true); setError('')
    try { clearOperatorSession(); await signOut(auth) }
    catch { setError('Sign-out could not be completed. Please try again.'); setBusy(false) }
  }
  return <div className="min-h-screen bg-background">
    <header className="border-b border-border bg-card px-4 py-4 sm:px-8">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4">
        <Link to="/timesheet" className="font-semibold tracking-[0.12em]">ARTGOLD <span className="text-xs font-normal tracking-normal text-muted-foreground">TIMESHEET</span></Link>
        <nav aria-label="Timesheet navigation" className="flex flex-wrap items-center gap-5 text-sm">
          <Link to="/home">Home</Link>
          {hasWorkspaceAccess(role, 'exchange_desk') && <Link to="/exchange-desk">Exchange Desk</Link>}
          {hasWorkspaceAccess(role, 'product_listing') && <Link to="/product-listing">Product Listing</Link>}
          {personalTimesheet && <Link to="/timesheet">My timesheet</Link>}
          {['manager','admin'].includes(role) && <><Link to="/timesheet-review">Team management</Link><Link to="/artgold-admin">ArtGold Admin</Link></>}
          {role === 'admin' && <Link to="/settings">Settings</Link>}
          <FeatureRequestButton user={user} />
          <button onClick={leave} disabled={busy} className="rounded-lg border border-border px-3 py-2">{busy ? 'Signing out…' : 'Sign out'}</button>
        </nav>
      </div>
      <p className="mx-auto mt-3 max-w-5xl break-all text-xs text-muted-foreground">{user?.email}{personalTimesheet && ' · Signing out does not end your shift.'}</p>
      {error && <p role="alert" className="mx-auto mt-2 max-w-5xl text-sm text-destructive">{error}</p>}
    </header>
    <Outlet />
  </div>
}
